import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=25805727&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ContactUs-pc.css?vue&type=style&index=0&id=25805727&scoped=true&lang=css&"
import style1 from "../assets/css/ContactUs-phone.css?vue&type=style&index=1&id=25805727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25805727",
  null
  
)

export default component.exports